/**
 * Ochranný patch proti chybě "Cannot read properties of null (reading 'touches')",
 * která se může objevit v některých prohlížečích (Seznam Browser) nebo při interakcích s Bootstrap 5 modaly.
 *
 * Některé události (např. `touchstart`, `touchmove`) mohou za určitých okolností
 * obsahovat `event.touches === null` nebo `undefined`, což způsobí pád v knihovnách,
 * které očekávají vždy pole.
 *
 * Tento patch nastaví `event.touches = []` pokud neexistuje, čímž zabrání výjimkám.
 */

export default function () {
	const safeTouchWrapper = (e) => {
		try {
			if (!e || typeof e !== 'object') return;

			if (!e.touches || typeof e.touches.length === 'undefined') {
				e.touches = [];
			}
		} catch (_) {
			// Ignorujeme chyby, které by jinak spadly
		}
	};

	document.addEventListener('touchstart', safeTouchWrapper, {passive: true, capture: true});
	document.addEventListener('touchmove', safeTouchWrapper, {passive: true, capture: true});

}
